import get from 'lodash/get';
import omit from 'lodash/omit';
import pick from 'lodash/pick';

import { removeUnchangedValues } from '../utils/remove-unchanged-values';
import { isEditable } from './utils';

const draftReadOnlyProperties = [
  'isDraft',
  'draftAuthor',
  'draftReviewers',
  'draftApprovers',
  'draftOrigin',
];

export const renderOnlyProperties = ['selected', 'filteredOut'];

export function transformCampaignLineForPatch(line) {
  if (!isEditable(line) || !line.isDirty) return pick(line, ['id']);

  const partialLine = omit(line, [
    'number',
    'campaignId',
    'quoteLineId',
    'product',
    'country',
    'created',
    'lastModified',
    'createdBy',
    'lastModifiedBy',
    ...renderOnlyProperties,
    ...draftReadOnlyProperties,
    'isDirty',
  ]);
  partialLine.productId = line.product && line.product.id;
  partialLine.countryCode = get(line, ['country', 'code'], '');
  partialLine.adjustedFee /= 100;
  partialLine.originalFee /= 100;
  return partialLine;
}

/* eslint-disable no-param-reassign */
export default function transformForPatch(
  initialCampaign,
  campaign,
  renderCampaignLines,
) {
  const renderCampaign = removeUnchangedValues(campaign, initialCampaign);

  const partialCampaign = omit(renderCampaign, [
    'id',
    'number',
    'nCode',
    'campaignLines',
    'campaignLineIds',
    'brandIds',
    'quoteId',
    'brands',
    'account',
    'opportunity',
    'quote',
    'owner',
    'ownerId',
    'prioScoreMetadata',
    'created',
    'targetKpi',
    'targetKpiValue',
    'lastModified',
    'createdBy',
    'lastModifiedBy',
    'collaborators',
    'collaboratorIds',
    'merchants',
    'merchantIds',

    // deprecated budgets
    'budgetOnsite',
    'budgetPaidsocial',
    'budgetDisplaySearch',
    'budgetCi',
    'budgetCreative',
    'budgetOther',

    ...draftReadOnlyProperties,
  ]);

  if (partialCampaign.productMetas) {
    partialCampaign.productMetas = partialCampaign.productMetas.map(
      productMeta => omit(productMeta, ['useCollectionIds', 'useContentIds']),
    );
  }

  partialCampaign.campaignLines = (renderCampaign.campaignLineIds || [])
    .map(id => renderCampaignLines[id])
    .map(line => transformCampaignLineForPatch(line));

  return partialCampaign;
}
